export const SubmittedInvoiceJobType = {
  Reactive: 'Reactive',
  PPM: 'PPM'
} as const;

export const SubmittedInvoiceStatus = {
  Submitted: 'Submitted',
  Recalled: 'Recalled',
  Approved: 'Approved',
  Rejected: 'Rejected'
} as const;

export interface SubmittedInvoiceFilterDto {
  companyId?: string | null;
  jobType?: typeof SubmittedInvoiceJobType[keyof typeof SubmittedInvoiceJobType] | null;
  jobReferenceNumber?: string | null;
  vendorInvoiceNumber?: string | null;
  siteName?: string | null;
  status?: typeof SubmittedInvoiceStatus[keyof typeof SubmittedInvoiceStatus] | null;
  purchaseOrderNumber?: string | null;
  isActive?: boolean | null;
  pageNumber?: number;
  pageSize?: number;
}

export interface SubmittedInvoiceDto {
  id: string;
  vendorInvoiceNumber: string | null;
  status: string | null;
  sourceSystemPurchaseInvoiceReferenceId: string | null;
  notes: string | null;
  jobReferenceNumber: string | null;
  siteName: string | null;
  formattedPurchaseOrderNumber: string | null;
  jobType: string | null;
  subSite: string | null;
  companyName: string | null;
}

export interface SubmittedInvoicePageDto {
  items: SubmittedInvoiceDto[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}
